import { Modal } from 'antd';
import './VtxModal.scss';
import * as React from 'react';
import { ModalProps } from 'antd/lib/modal';
import { FunctionComponent } from 'react';
import classNames from 'classnames';
import { IAutomatable, preventDataAutomationOverriding } from '../../helpers/IAutomatable';
import { VtxIcon } from '../icon/VtxIcon';
import { VtxButtonProps, vtxButtonPropsToAntDProps } from '../button/VtxButton';
import '../button/VtxButton.scss';

export interface VtxModalProps
    extends Omit<ModalProps, 'centered' | 'closeIcon' | 'okButtonProps' | 'cancelButtonProps' | 'okType'>,
        IAutomatable {
    okButtonProps?: VtxButtonProps;
    cancelButtonProps?: VtxButtonProps;
}

export const VtxModal: FunctionComponent<VtxModalProps> = React.memo((props: VtxModalProps) => {
    const automationClass = 'vtx-modal';
    const {
        okButtonProps,
        cancelButtonProps,
        wrapClassName,
        ...otherProps
    } = preventDataAutomationOverriding(props);
    const wrapclassNamesCombined = classNames(automationClass, wrapClassName);

    const antdOkButtonProps = okButtonProps
        ? vtxButtonPropsToAntDProps(okButtonProps)
        : vtxButtonPropsToAntDProps({ type: 'primary' });

    const antdCancelButtonProps = cancelButtonProps
        ? vtxButtonPropsToAntDProps(cancelButtonProps)
        : vtxButtonPropsToAntDProps({ type: 'default' });

    return (
        <Modal
            wrapClassName={wrapclassNamesCombined}
            centered
            {...otherProps}
            wrapProps={{
                'data-automation-class': automationClass,
            }}
            cancelButtonProps={antdCancelButtonProps}
            okButtonProps={antdOkButtonProps}
            closeIcon={<VtxIcon type="close" fontSize={20} />}
        ></Modal>
    );
});
